(function () {
  if (window.__dtKaching) return;
  window.__dtKaching = true;

  let frame;
  let oneTimeUnit;

  const money = el => {
    if (!el) return null;

    const text = el.textContent.trim();
    const value = parseFloat(text.replace(/[^0-9.]/g, ''));

    if (!Number.isFinite(value)) return null;

    return {
      value,
      symbol: text.match(/^[^\d.,-]+/)?.[0]?.trim() || '$'
    };
  };

  const unitDisplay = (pricing, cls, value, symbol) => {
    let el = pricing.querySelector(`.${cls}`);

    if (!el) {
      el = document.createElement('div');
      el.className = cls;

      el.innerHTML =
        `<span class="${cls}__amount"></span>` +
        `<span class="${cls}__label">per bottle</span>`;

      pricing.appendChild(el);
    }

    el.querySelector(`.${cls}__amount`).textContent =
      `${symbol}${value.toFixed(2)}`;
  };

  const updateSubscription = bar => {
    const pricing = bar.querySelector('.kaching-bundles__bar-pricing');
    const price = money(bar.querySelector('.kaching-bundles__bar-price'));

    if (!pricing || !price) return;

    unitDisplay(
      pricing,
      'dt-sub-unit-price',
      price.value / 2,
      price.symbol
    );
  };

  const updateOneTime = bar => {
    const pricing = bar.querySelector('.kaching-bundles__bar-pricing');
    const priceEl = bar.querySelector('.kaching-bundles__bar-price');
    const price = money(priceEl);

    if (!pricing || !price) return;

    const input = bar.querySelector(
      'input[name="quantity"], input[type="number"]'
    );

    const qty = Math.max(
      1,
      parseInt(input?.value || 1, 10) || 1
    );

    if (input) {
      oneTimeUnit = price.value / qty;
    } else if (!oneTimeUnit) {
      oneTimeUnit = price.value;
    }

    unitDisplay(
      pricing,
      'dt-one-time-unit-price',
      oneTimeUnit,
      price.symbol
    );

    bar.classList.add('dt-one-time-unit-price-ready');
  };

  const addBonuses = bar => {
    const main = bar.querySelector('.kaching-bundles__bar-main');

    if (!main || main.querySelector('.dt-sub-bonuses')) return;

    main.insertAdjacentHTML('beforeend', `
      <div class="dt-sub-bonuses">

        <div class="dt-sub-bonuses__title">
          SUBSCRIPTION BONUSES ($60+ VALUE)
        </div>

        <div class="dt-sub-bonuses__grid">

          <div class="dt-bonus">
            <strong>ORDER 2</strong>

            <svg viewBox="0 0 64 52" aria-hidden="true">
              <path d="M15 4v21c0 4-2 7-6 10l-4 3c-3 2-3 6-1 8 3 3 8 2 12 0l8-5c5-3 7-7 7-13V4H15ZM34 8v19c0 4-2 7-5 9l-4 3c-3 2-3 5-1 7 3 3 7 2 11 0l7-5c4-3 6-6 6-11V8H34Z"/>
              <path class="dt-accent" d="M15 13h16M34 17h14"/>
            </svg>

            <b>FREE</b>

            <span>
              Embroidered<br>
              Socks
            </span>
          </div>


          <div class="dt-bonus">
            <strong>ORDER 4</strong>

            <svg viewBox="0 0 64 52" aria-hidden="true">
              <path d="M10 18 25 7h29v26L39 45H10V18ZM10 28h29l15-11M10 36h29l15-11"/>
              <path class="dt-accent" d="M28 22h13"/>
            </svg>

            <b>FREE</b>

            <span>Tuggs Towel</span>
          </div>


          <div class="dt-bonus">
            <strong>1 YEAR</strong>

            <svg viewBox="0 0 64 52" aria-hidden="true">
              <path d="M11 21h42v26H11V21ZM8 15h48v10H8V15ZM32 15v32M31 14c-8-1-12-4-12-8 0-3 3-5 6-4 5 1 7 7 7 12ZM33 14c8-1 12-4 12-8 0-3-3-5-6-4-5 1-7 7-7 12Z"/>
              <path class="dt-accent" d="M32 25v10"/>
            </svg>

            <b>FREE</b>

            <span>Mystery Gift</span>
          </div>

        </div>
      </div>
    `);
  };

  const update = () => {
    frame = null;

    const bars = document.querySelectorAll(
      '.kaching-bundles__bar'
    );

    if (bars.length < 2) return;

    updateSubscription(bars[0]);
    updateOneTime(bars[1]);
    addBonuses(bars[0]);
  };

  const schedule = () => {
    if (!frame) {
      frame = requestAnimationFrame(update);
    }
  };

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      schedule
    );
  } else {
    schedule();
  }
})();